import { required, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
  reset: {
    password: {
      required,
      minLength: minLength(6)
    },
    password_confirmation: {
      required,
      minLength: minLength(6),
      sameAsPassword: sameAs('password')
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/reset/resources/validations.js